const SalesgroupIndicator = ['salesGroupId'];
const TrimIndicator = ['trimName'];
const EngineIndicator = ['modelId', 'modelVersion', 'modelYear'];
const EngineWithOptionsIndicator = [
    'exteriorId',
    'interiorId',
    'options'
];
const MandatoryFieldsForCarline = ['category', 'carlineId'];
const MandatoryFieldsForTrimOrSalesgroup = [
    'salesGroupId',
    ...MandatoryFieldsForCarline
];
const MandatoryFieldsForEngine = [
    ...EngineIndicator,
    ...MandatoryFieldsForTrimOrSalesgroup
];
const Validations = [
    {
        keys: EngineWithOptionsIndicator,
        mandatoryKeys: MandatoryFieldsForEngine
    },
    {
        keys: EngineIndicator,
        mandatoryKeys: MandatoryFieldsForEngine
    },
    {
        keys: TrimIndicator,
        mandatoryKeys: MandatoryFieldsForTrimOrSalesgroup
    },
    {
        keys: SalesgroupIndicator,
        mandatoryKeys: MandatoryFieldsForTrimOrSalesgroup
    },
    {
        keys: ['carlineId'],
        mandatoryKeys: ['category']
    }
];
export function validateConfiguration(configuration) {
    if (!configuration) {
        return undefined;
    }
    const validationItem = Validations.find(mapping => mapping.keys.some(key => Boolean(configuration[key])));
    if (validationItem) {
        return validationItem.mandatoryKeys.reduce((missingFields, key) => {
            if (!configuration[key]) {
                return [...missingFields, key];
            }
            return missingFields;
        }, []);
    }
    return [];
}
export function isCategoryConfiguration(configuration) {
    return Boolean(configuration && configuration.category);
}
export function isCarlineConfiguration(configuration) {
    return (Boolean(configuration && configuration.carlineId) && isCategoryConfiguration(configuration));
}
export function isSalesgroupConfiguration(configuration) {
    if (!configuration) {
        return false;
    }
    const cfg = configuration;
    return Boolean(cfg.salesGroupId && isCarlineConfiguration(configuration));
}
export function isTrimConfiguration(configuration) {
    if (!configuration) {
        return false;
    }
    const cfg = configuration;
    return Boolean(cfg.trimName && isSalesgroupConfiguration(configuration));
}
export function isEngineConfiguration(configuration) {
    if (!configuration) {
        return false;
    }
    const cfg = configuration;
    return Boolean(cfg.modelId &&
        cfg.modelVersion &&
        cfg.modelYear &&
        isSalesgroupConfiguration(configuration) // trimName is not required, so we check for salesgroup
    );
}
